// eslint-disable-next-line max-lines-per-function
define( [ 'utility' ], function run( utility ) {
	'use strict';

	var mTabsFn = {
		// Default settings
		defaults : {
			loadingText : FRAMEWORK.locale.settings.mTabs.loadingText,
			tabsPrimary : false,
			tabsLazy : false,
			tabsStatic : false,
			offset : 50, // 0px indent + 30px button + 5px space + 15px gradient
			offsetPrimaryMobile : 60, // 20px indent + 30px button - 10px so arrow aligns + 5px space + 15px gradient
			offsetPrimaryOther : 70, // 30px indent + 30px button - 10px so arrow aligns + 5px space + 15px gradient
			previousPage : FRAMEWORK.locale.settings.mTabs.previousText,
			nextPage : FRAMEWORK.locale.settings.mTabs.nextText,
			carouselActive : false,
			scrollLock : false,
			direction : {
				Left : -1,
				ArrowLeft : -1,
				Right : 1,
				ArrowRight : 1,
				Home : 0,
				End : 0,
			},
		},

		init : function( elm ) {
			var tabsList;

			if ( !elm.classList.contains( 'js-m-tabs' ) ) {
				elm.classList.add( 'js-m-tabs' );

				elm.mTabs = {};

				// Set settings from defaults and any specified options
				elm.mTabs.settings = utility.extend({}, mTabsFn.defaults, utility.getData( elm ) );

				// Set up markup, add a link to each control pointing to an id set on the following element and move into anchors div
				elm.mTabs.tabsHeadings = Array.from( elm.querySelectorAll( '.m-tabs__heading' ) ).filter( function filterFn( heading ) {
					return heading.closest( '.m-tabs' ) === elm && mTabsFn.filterParents( heading, 'm-tabs__content' ) === false;
				});

				// Catch primary tabs instance and set settings accordingly
				if ( elm.classList.contains( 'o-tabs-primary__tabs' ) ) {
					elm.mTabs.settings.tabsPrimary = true;
				}

				// Catch subheadings and icon headings and add classes accordingly
				elm.mTabs.tabsHeadings.forEach( function loop( heading ) {
					if ( heading.querySelectorAll( '.m-tabs__subheading' ).length > 0 ) {
						elm.classList.add( 'm-tabs--subheadings' );
					} else if ( heading.querySelectorAll( '.m-tabs-icon' ).length > 0 ) {
						elm.classList.add( 'm-tabs--icons' );
					}
				});

				// Catch links variants and set settings accordingly
				if ( elm.classList.contains( 'm-tabs--links' ) ) {
					// All links variants
					tabsList = elm.querySelector( '.m-tabs__list' );
					tabsList.remove();
					elm.mTabs.tabsHeadings.forEach( function loop( heading, index ) {
						if ( !heading.getAttribute( 'href' ) ) {
							elm.mTabs.tabsHeadings.splice( index, 1 );
						}
						// Or just remove the bloody thing altogether...
					});
					if ( elm.classList.contains( 'm-tabs--links-lazy' ) ) {
						// Set lazy links flag and set up accordingly
						elm.mTabs.settings.tabsLazy = true;
						mTabsFn.tabsLazy( elm );
					} else {
						// Set static tabs flag
						elm.mTabs.settings.tabsStatic = true;
						mTabsFn.tabsStatic( elm );
					}
				}

				elm.mTabs.navList = [];
				elm.mTabs.tabsHeadings.forEach( function loop( heading ) {
					var elementID = heading.getAttribute( 'id' );
					elm.mTabs.autoID = utility.makeId( 'm-tabs-' );
					elm.mTabs.hrefID = '#' + elm.mTabs.autoID;
					elm.mTabs.staticID = heading.getAttribute( 'href' );

					if ( elementID ) { // Pre-existing element ID, so use that instead
						elm.mTabs.autoID = elementID;
						elm.mTabs.hrefID = '#' + elm.mTabs.autoID;
					}

					heading.removeAttribute( 'id' );
					heading.classList.add( 'u-hidden--visually' );

					mTabsFn.setupControls( elm, heading );


					if ( !elm.mTabs.settings.tabsStatic ) {
						heading.nextElementSibling.id = elm.mTabs.autoID;
						heading.nextElementSibling.setAttribute( 'aria-hidden', 'true' );
						heading.nextElementSibling.style.display = 'none';
					}
				});

				// Set up the heading controls
				mTabsFn.tabsMain( elm );

				elm.mTabs.open = function open( targetId, scrollTo ) {
					var parentsList,
						scrollParent,
						moveTo,
						thisTabContent;

					if ( mTabsFn.openTab( elm, targetId ) ) {
						parentsList = utility.parents( elm, '.m-tabs__content' );
						parentsList.forEach( function parentLoop( parentEl ) {
							mTabsFn.openTab( parentEl.closest( '.js-m-tabs' ), '#' + parentEl.id );
						});

						if ( scrollTo ) {
							thisTabContent = elm.querySelector( targetId );
							scrollParent = utility.scrollParent( thisTabContent );
							moveTo = thisTabContent.offsetTop - scrollParent.offsetTop;

							scrollParent.scrollTo( 0, moveTo );
						}
					}
				};
			}
			return elm.mTabs;
		},

		setupControls : function( elm, heading ) {
			// Generate a string 'dataAttrs' from the non-js links containing all data attributes for replacing in the control
			let dataAttrs = '';
			// Data class variable depends on presence of dataset in dataAttrs
			let dataClass = '';
			// Retain datasets for click tracking
			Object.keys( heading.dataset ).forEach( key => {
				// Fix hyphenated key names
				let keyString = '';
				// Split data key into an array around uppercase with match if required
				let tempArr = key.match( /[A-Za-z][a-z]+/g );
				// Concatenate and drop to lowercase - unless there is no split array in which case use key
				keyString = tempArr === null ? keyString = key : keyString += 'data-' + tempArr.join( '-' ).toLowerCase();
				// Build the data attribute string for insertion
				dataAttrs += keyString + '="' + heading.dataset[ key ] + '"';
			});
			// If dataAttrs contains dataset add data class to dataClass
			dataClass = dataAttrs.includes( 'data-dd-' ) ? dataClass = 'dd-data-link' : dataClass;

			if ( elm.mTabs.settings.tabsLazy === true && heading.classList.contains( 'js-m-tab-open' ) ) {
				// Lazy-load tabs open tab only - need standard link url, aria-controls and aria-selected, plus data-href for ajax load call
				// eslint-disable-next-line max-len
				elm.mTabs.navList += '<li role="presentation"><a class="m-tabs__control js-m-tab-open ' + dataClass + '" href="' + elm.mTabs.hrefID + '"' + dataAttrs + ' role="tab" id="' + elm.mTabs.autoID + '-tab" aria-controls="' + elm.mTabs.autoID + '"  aria-selected="true"><div class="m-tabs__control-inner">' + heading.innerHTML + '</div></a></li>';
			} else if ( elm.mTabs.settings.tabsLazy === true ) {
				// Lazy-load tabs - need standard link url, aria-controls and aria-selected, plus data-href for ajax load call
				// eslint-disable-next-line max-len
				elm.mTabs.navList += '<li role="presentation"><a class="m-tabs__control ' + dataClass + '" href="' + elm.mTabs.hrefID + '"' + dataAttrs + ' role="tab"  id="' + elm.mTabs.autoID + '-tab" aria-controls="' + elm.mTabs.autoID + '" aria-selected="false"><div class="m-tabs__control-inner">' + heading.innerHTML + '</div></a></li>';
			} else if ( elm.mTabs.settings.tabsStatic === true && heading.classList.contains( 'js-m-tab-open' ) ) {
				// Static tabs open tab only - needs skip link url but no aria-controls
				// eslint-disable-next-line max-len
				elm.mTabs.navList += '<li role="presentation"><a class="m-tabs__control js-m-tab-open ' + dataClass + '" href="' + elm.mTabs.staticID + '"' + dataAttrs + '><div class="m-tabs__control-inner">' + heading.innerHTML + '</div></a></li>';
			} else if ( elm.mTabs.settings.tabsStatic === true ) {
				// Static tabs - need external link url but no aria-controls or aria-selected
				// eslint-disable-next-line max-len
				elm.mTabs.navList += '<li role="presentation"><a class="m-tabs__control ' + dataClass + '" href="' + elm.mTabs.staticID + '"' + dataAttrs + '><div class="m-tabs__control-inner">' + heading.innerHTML + '</div></a></li>';
			} else if ( heading.classList.contains( 'js-m-tab-open' ) ) {
				// Standard tabs open tab only - need standard link url, aria-controls and aria-selected
				// eslint-disable-next-line max-len
				elm.mTabs.navList += '<li role="presentation"><a class="m-tabs__control js-m-tab-open ' + dataClass + '" href="' + elm.mTabs.hrefID + '"' + dataAttrs + ' role="tab"  id="' + elm.mTabs.autoID + '-tab" aria-controls="' + elm.mTabs.autoID + '" aria-selected="true"><div class="m-tabs__control-inner">' + heading.innerHTML + '</div></a></li>';
			} else {
				// Standard tabs - need standard link url, aria-controls and aria-selected
				// eslint-disable-next-line max-len
				elm.mTabs.navList += '<li role="presentation"><a class="m-tabs__control ' + dataClass + '" href="' + elm.mTabs.hrefID + '"' + dataAttrs + ' role="tab"  id="' + elm.mTabs.autoID + '-tab" aria-controls="' + elm.mTabs.autoID + '" aria-selected="false"><div class="m-tabs__control-inner">' + heading.innerHTML + '</div></a></li>';
			}
		},

		filterParents : function( element, needle ) {
			// Check if the specified needle class is in the parents further up the DOM; if found, return true
			utility.parents( element ).forEach( function loop( parent ) {
				return parent.classList.contains( needle );
			});

			// If not found, return false
			return false;
		},

		tabsMain : function( elm ) {
			// Main part of function for all variants
			var mainHeading,
				accentClassesArray,
				accentClasses;

			elm.mTabs.tabsNav = document.createElement( 'div' );
			elm.mTabs.tabsNav.classList.add( 'm-tabs__nav' );

			// Add accent colour background to match heading area for primary nav instances
			if ( elm.mTabs.settings.tabsPrimary === true ) {
				mainHeading = elm.parentNode.querySelectorAll( '.o-tabs-primary__heading' );
				accentClassesArray = Array.from( mainHeading[ 0 ].classList ).filter( function filterFn( classes ) {
					return classes.indexOf( 't-accent' ) !== -1;
				});
				if ( accentClassesArray.length === 0 ) {
					// If no accent classes presset, set to white so the carousel elements colour correctly
					accentClassesArray = [ 't-accent-light', 't-accent-light--2' ];
				}
				accentClasses = ' ' + accentClassesArray.toString().replace( ',', ' ' );
				utility.addClass( elm.mTabs.tabsNav, accentClasses );
			}

			// Define and set up nav list, headings, controls and contents
			utility.wrapInner( elm.mTabs.tabsNav, utility.htmlStringToElement( '<ul class="m-tabs__nav-list a-list-plain">' + elm.mTabs.navList + '</ul>' ) );

			elm.insertBefore( elm.mTabs.tabsNav, elm.firstElementChild );
			elm.mTabs.tabsNavList = elm.querySelector( '.m-tabs__nav-list' ); // Returns first instance, which is what we want anyway
			elm.mTabs.tabsNavList.setAttribute( 'role', 'tablist' );
			elm.mTabs.tabsNavList.setAttribute( 'tabindex', -1 ); // Set tabindex to -1 to stop Firefox allowing focus when its not needed
			elm.mTabs.tabsListItems = elm.mTabs.tabsNavList.querySelectorAll( 'li' );
			elm.mTabs.tabsCount = elm.mTabs.tabsListItems.length;
			elm.mTabs.tabsControls = Array.from( elm.mTabs.tabsNavList.querySelectorAll( '.m-tabs__control' ) );
			elm.mTabs.tabsContents = Array.from( elm.querySelectorAll( '.m-tabs__content' ) ).filter( function filterFn( content ) {
				return content.closest( '.m-tabs' ) === elm && mTabsFn.filterParents( content, 'm-tabs__content' ) === false;
			});

			// Set up initially selected tab control - tab already marked as open
			elm.mTabs.windowHash = window.location.hash;
			elm.mTabs.tabsControls.forEach( function loop( tabControl ) {
				tabControl.setAttribute( 'role', 'tab' );
				tabControl.setAttribute( 'aria-selected', 'false' );
				tabControl.setAttribute( 'tabindex', -1 );

				// If pointing to a specific anchor within a tab section, add open tab class
				if ( elm.mTabs.windowHash ) {
					tabControl.classList.remove( 'js-m-tab-open' ); // Remove any existing force-opened tabs...
					if ( tabControl.getAttribute( 'href' ).match( elm.mTabs.windowHash ) ) {
						tabControl.classList.add( 'js-m-tab-open' ); // ...and replace with the one from the url parameter
					}
				}

				tabControl.parentElement.setAttribute( 'role', 'presentation' );

				tabControl.addEventListener( 'keydown', function listener( e ) {
					var pressed = e.key,
						direction = elm.mTabs.settings.direction[ pressed ];

					// Catch Arrow, Home or End key presses before they are processed for the page
					if ( Number.isInteger( direction ) ) {
						e.preventDefault();
						mTabsFn.switchTabOnArrowPress( elm, e );
					} else if ( pressed === ' ' || pressed === 'Spacebar' ) {
						e.preventDefault();
						tabControl.click();
					}
				});
			});

			mTabsFn.setOpenTab( elm );

			elm.mTabs.tabsContents.forEach( function loop( tabContent ) {
				tabContent.setAttribute( 'role', 'tabpanel' );
				tabContent.setAttribute( 'aria-labelledby', tabContent.id + '-tab' );
			});

			// Set up click event listeners
			if ( elm.mTabs.settings.tabsStatic === true ) {
				// Static tab - do nothing, as link needs to function normally
			} else {
				// Everything else
				elm.mTabs.tabsControls.forEach( function loop( tabControl ) {
					tabControl.addEventListener( 'click', function listener( e ) {
						e.preventDefault();
						mTabsFn.tabClick( elm, tabControl );
					});
				});
			}

			// Icon tabs
			if ( elm.classList.contains( 'm-tabs--icons' ) ) {
				elm.mTabs.tabsControls.forEach( function loop( tabControlInner ) {
					var span = tabControlInner.querySelector( 'span' ),
						tabIcon,
						tabIconClone,
						subhead;

					if ( span ) {
						tabIcon = span.querySelector( 'img' );
						subhead = span.querySelector( '.m-tabs__subheading' );

						// Remove any subheadings added by UX-rule-defying muppets
						if ( subhead ) {
							span.removeChild( subhead );
						}

						// Duplicate images to allow crossfading
						tabIcon.classList.add( 'm-tabs-icon__image--default' );
						tabIconClone = tabIcon.cloneNode( true );
						span.append( tabIconClone );
						tabIconClone.classList.remove( 'm-tabs-icon__image--default' );
						tabIconClone.classList.add( 'm-tabs-icon__image--selected' );
					}
				});
			}

			// Process all the page links
			mTabsFn.tabsPageLinks( elm );
		},

		setOpenTab : function( elm ) {
			var openTab = elm.querySelector( '.m-tabs__control.js-m-tab-open' ),
				openTabContent,
				scrollLeftPos;

			// Set up initially selected tab control - none marked as open, so use first tab
			if ( typeof openTab === 'object' && openTab !== null ) {
				openTab.classList.add( 'm-tabs__control--selected' );
				openTab.setAttribute( 'aria-selected', 'true' );
				openTab.removeAttribute( 'tabindex' );

				if ( elm.mTabs.settings.tabsStatic === true || elm.mTabs.settings.tabsLazy === true ) {
					// Pre-opened static tab
					openTabContent = elm.mTabs.tabsContents[ 0 ];
					utility.trigger( window, 'refresh' );
				} else {
					// Pre-opened standard tab
					openTab.classList.remove( 'js-m-tab-open' );
					openTabContent = elm.mTabs.tabsContents.filter( function filterFn( contents ) {
						return ( contents.id === openTab.getAttribute( 'href' ).substr( 1 ) );
					})[ 0 ];

					if ( elm.mTabs.settings.scrollLock ) {
						// Prevent scolling when already scrolling
					} else {
						scrollLeftPos = openTab.parentNode.offsetLeft - elm.mTabs.settings.offset;
						elm.mTabs.tabsNavList.scrollTo( scrollLeftPos, 0 );
					}
				}
				// If pointing to a specific anchor within a tab section, scroll to that tab
				if ( elm.mTabs.windowHash ) {
					setTimeout( function timeoutFn() {
						window.scrollTo( 0, utility.offset( openTab ).top );
					}, 100 );
				}
			} else {
				openTab = elm.mTabs.tabsControls[ 0 ];
				openTab.classList.add( 'm-tabs__control--selected' );
				openTab.setAttribute( 'aria-selected', 'true' );
				openTab.removeAttribute( 'tabindex' );
				openTabContent = elm.mTabs.tabsContents[ 0 ];
				utility.trigger( window, 'refresh' );
			}

			// Open content matching initially selected tab control
			openTabContent.classList.add( 'm-tabs__content--selected' );
			openTabContent.setAttribute( 'aria-hidden', 'false' );
			openTabContent.style.display = 'block';
			if ( openTabContent.previousElementSibling.classList.contains( '.m-tabs__heading' ) ) {
				openTabContent.previousElementSibling.removeAttribute( 'style' );
			}
		},

		openTab : function( elm, thisHref ) {
			var href = thisHref,
				targetElm,
				tempElm,
				tabContentElm,
				openedTab = false;

			if ( thisHref.indexOf( '#' ) === 0 ) {
				href = '#' + CSS.escape( thisHref.substr( 1 ) );
			}

			targetElm = elm.querySelector( href );

			// If target element exists within tab component then carry on processing
			if ( targetElm && elm.contains( targetElm ) ) {
				// Loop through until you find the outer most tab content area
				tempElm = targetElm.closest( '.m-tabs__content' );
				while ( tempElm && elm.contains( tempElm ) ) {
					tabContentElm = tempElm;
					tempElm = tabContentElm.parentNode.closest( '.m-tabs__content' );
				}
				mTabsFn.tabClick( elm, elm.mTabs.tabsNavList.querySelector( 'a[href="#' + CSS.escape( tabContentElm.id ) + '"]' ), true );

				openedTab = true;
			}
			return openedTab;
		},

		tabsPageLinks : function( elm ) {
			var href = utility.getAnchor(),
				openedTab = false,
				tabOpen,
				nextElement,
				tempElm;

			document.addEventListener( 'click', function listener( e ) {
				var element = e.target,
					thisHref;

				// Get the href of the clicked element if there is one
				if ( element.hasAttribute( 'href' ) ) {
					thisHref = element.getAttribute( 'href' ).match( utility.urlAnchorRegExp );
				} else {
					element = element.closest( 'a[href], button[href]' );
					if ( element ) {
						thisHref = element.getAttribute( 'href' ).match( utility.urlAnchorRegExp );
					}
				}

				// Only try and process if the link is not blank
				if ( Array.isArray( thisHref ) && thisHref[ 0 ] !== '' && !element.classList.contains( 'm-tabs__control' ) && !element.classList.contains( 'm-tabs-nextprev' ) ) {
					mTabsFn.openTab( elm, thisHref[ 0 ] );
				}
			});

			// Open the associated element when the incoming link points to an id on a control
			if ( Array.isArray( href ) && href[ 0 ] !== '' ) {
				openedTab = mTabsFn.openTab( elm, href[ 0 ] );
			}

			// No incoming link, so check for pre-opened flag instead
			if ( !openedTab ) {
				tabOpen = elm.querySelector( '.js-m-tab-open' );
				if ( tabOpen ) {
					// If one exists, click the appropriate heading anchor
					if ( elm.mTabs.settings.tabsLazy ) {
						tempElm = tabOpen.closest( '.m-tabs__content' );
						if ( tempElm && elm.contains( tempElm ) ) {
							// Not this set of tabs, so need to find which tab we are within
							mTabsFn.openTab( elm, '#' + tempElm.id );
						} else {
							mTabsFn.tabClick( elm, tabOpen, true );
							window.scrollTo( 0, utility.offset( tabOpen ).top );
						}
					} else {
						nextElement = tabOpen.nextElementSibling;
						if ( nextElement ) {
							mTabsFn.openTab( elm, '#' + nextElement.id );
						}
					}
				}
			}

			// Run resize/refresh function and setup carousel if necessary
			mTabsFn.resizeRefresh( elm );
		},

		tabsCarousel : function( elm ) {
			var backgroundElm,
				backgroundColor,
				stopOpaque,
				stopTransparent,
				stopTemp,
				onScroll = utility.debounce( function listener() {
					mTabsFn.updatePagination( elm );
				}, 10 );

			elm.mTabs.settings.carouselActive = true;
			elm.mTabs.tabsNav.classList.add( 'm-tabs__nav--carousel' );

			// Get breakpoint and set offsets
			elm.mTabs.currentBreakpoint = utility.getBreakpoint();
			if ( !elm.mTabs.settings.tabsPrimary ) {
				// Standard - use default
			} else if ( elm.mTabs.currentBreakpoint === utility.smallTag ) {
				elm.mTabs.settings.offset = elm.mTabs.settings.offsetPrimaryMobile; // Primary mobile
			} else {
				elm.mTabs.settings.offset = elm.mTabs.settings.offsetPrimaryOther; // Primary tablet and desktop
			}

			// Setup pagination
			elm.mTabs.pagination = utility.htmlStringToElement( '<ul class="m-tabs__nav-pagination a-list-plain">' +
				'<li class="m-tabs__nav-pagination-prev"><button class="m-tabs-nextprev" type="button" disabled><span>' + elm.mTabs.settings.previousPage +
				'</span></button></li>' +
				'<li class="m-tabs__nav-pagination-next"><button class="m-tabs-nextprev" type="button" disabled><span>' + elm.mTabs.settings.nextPage + '</span></button></li>' +
				'</ul>' );

			// Setup previous and next buttons
			elm.mTabs.prevButton = elm.mTabs.pagination.querySelector( '.m-tabs__nav-pagination-prev' );
			elm.mTabs.prevButtonTarget = elm.mTabs.prevButton.firstChild;
			elm.mTabs.nextButton = elm.mTabs.pagination.querySelector( '.m-tabs__nav-pagination-next' );
			elm.mTabs.nextButtonTarget = elm.mTabs.nextButton.firstChild;

			elm.mTabs.prevButtonTarget.addEventListener( 'click', function listener() {
				elm.mTabs.direction = 'prev';
				mTabsFn.setCarouselPosition( elm );
			});
			elm.mTabs.nextButtonTarget.addEventListener( 'click', function listener() {
				elm.mTabs.direction = 'next';
				mTabsFn.setCarouselPosition( elm );
			});

			elm.mTabs.nextButtonTarget.classList.add( 'm-tabs-nextprev--active' );
			elm.mTabs.nextButtonTarget.removeAttribute( 'disabled' );

			elm.mTabs.tabsNavList.addEventListener( 'scroll', onScroll );

			// Append the pagination
			elm.mTabs.tabsNav.append( elm.mTabs.pagination );

			// Get background colour and use it to apply transparency gradients behind prev / next arrows
			backgroundElm = elm.mTabs.pagination.closest( '.t-card-accent-light .m-card, .t-card-accent-dark .m-card, .t-accent-light, .t-accent-dark' );
			if ( elm.mTabs.settings.tabsPrimary ) {
				// Primary tabs - just get tabsNav background colour
				backgroundColor = getComputedStyle( elm.mTabs.tabsNav ).backgroundColor;
			} else if ( backgroundElm && typeof getComputedStyle( backgroundElm ).backgroundColor !== 'undefined' ) {
				// Standard tabs - work back up the DOM to find closest element with a background colour
				backgroundColor = getComputedStyle( backgroundElm ).backgroundColor;
			} else {
				backgroundColor = '#fff';
			}

			// Convert background colour to rgba
			if ( backgroundColor.indexOf( '#' ) === 0 ) {
				// ...from hex
				stopOpaque = utility.hexToRgba( backgroundColor );
				stopTransparent = stopOpaque.replace( '1)', '0)' );
			} else {
				// ...from rgb
				stopTemp = backgroundColor.replace( 'rgb(', 'rgba(' );
				stopOpaque = stopTemp.replace( ')', ', 1)' );
				stopTransparent = stopOpaque.replace( '1)', '0)' );
			}

			if ( elm.mTabs.currentBreakpoint === utility.smallTag ) {
				// Primary mobile
				elm.mTabs.prevButtonTarget.style.backgroundImage = 'linear-gradient(to right, ' + stopOpaque + ' 75%, ' + stopTransparent + ')';
				elm.mTabs.nextButtonTarget.style.backgroundImage = 'linear-gradient(to right, ' + stopTransparent + ', ' + stopOpaque + ' 25%)';
			} else if ( elm.mTabs.currentBreakpoint === utility.mediumTag || elm.mTabs.currentBreakpoint === utility.largeTag ) {
				// Primary tablet and desktop
				elm.mTabs.prevButtonTarget.style.backgroundImage = 'linear-gradient(to right, ' + stopOpaque + ' 78.5%, ' + stopTransparent + ')';
				elm.mTabs.nextButtonTarget.style.backgroundImage = 'linear-gradient(to right, ' + stopTransparent + ', ' + stopOpaque + ' 21.5%)';
			} else {
				// Standard
				elm.mTabs.prevButtonTarget.style.backgroundImage = 'linear-gradient(to right, ' + stopOpaque + ' 70%, ' + stopTransparent + ')';
				elm.mTabs.nextButtonTarget.style.backgroundImage = 'linear-gradient(to right, ' + stopTransparent + ', ' + stopOpaque + ' 30%)';
			}

			elm.mTabs.currentIndexes = mTabsFn.getCurrentIndexes( elm );
		},

		updatePagination : function( elm ) {
			var farRight = elm.mTabs.tabsNavList.scrollWidth - elm.mTabs.tabsNavList.offsetWidth;

			if ( elm.mTabs.tabsNavList.scrollLeft <= 0 ) {
				elm.mTabs.prevButtonTarget.classList.remove( 'm-tabs-nextprev--active' );
				elm.mTabs.prevButtonTarget.setAttribute( 'disabled', true );
			} else {
				elm.mTabs.prevButtonTarget.classList.add( 'm-tabs-nextprev--active' );
				elm.mTabs.prevButtonTarget.removeAttribute( 'disabled' );
			}
			if ( elm.mTabs.tabsNavList.scrollLeft >= farRight - 2 ) { // Minus 2 to allow for a tiny bit of tollerance
				elm.mTabs.nextButtonTarget.classList.remove( 'm-tabs-nextprev--active' );
				elm.mTabs.nextButtonTarget.setAttribute( 'disabled', true );
			} else {
				elm.mTabs.nextButtonTarget.classList.add( 'm-tabs-nextprev--active' );
				elm.mTabs.nextButtonTarget.removeAttribute( 'disabled' );
			}
		},

		getCurrentIndexes : function( elm ) {
			var elmIndent = elm.getBoundingClientRect().left + 50,
				leftIndex = 0,
				leftIndexSet = false,
				rightIndex = 0;

			elm.mTabs.tabsControls.forEach( function loop( listItem, index ) {
				var listItemAbsoluteLeft = listItem.getBoundingClientRect().left - elmIndent,
					farRight = elm.getBoundingClientRect().right - 50,
					listItemAbsoluteRight = listItem.getBoundingClientRect().right;

				if ( utility.inRange( listItemAbsoluteLeft, 0, 5 ) ) {
					leftIndex = index;
					leftIndexSet = true;
				} else if ( listItemAbsoluteLeft > 0 && !leftIndexSet ) {
					leftIndex = index;
					leftIndexSet = true;
				} else {
					// Do nothing
				}
				if ( listItemAbsoluteRight < farRight ) {
					rightIndex = index;
				}
			});

			return [ leftIndex, rightIndex ];
		},

		/* eslint-disable-next-line complexity */
		setCarouselPosition : function( elm ) {
			var currentIndex,
				nextIndex,
				prevIndex,
				scrollLeftPos,
				i = 0,
				farRight = elm.mTabs.tabsNavList.scrollWidth - elm.mTabs.tabsNavList.offsetWidth,
				tabAreaWidth = elm.mTabs.tabsNavList.offsetWidth - 100 + 30,
				listItemWidthTotal = 0;

			if ( elm.mTabs.settings.scrollLock ) {
				// Prevent scolling when already scrolling
			} else {
				elm.mTabs.settings.scrollLock = true;
				elm.mTabs.currentIndexes = mTabsFn.getCurrentIndexes( elm );

				if ( elm.mTabs.direction === 'prev' ) {
					currentIndex = elm.mTabs.currentIndexes[ 0 ];
					if ( currentIndex > 0 ) {
						prevIndex = currentIndex - 1;

						for ( i = prevIndex; i >= 0; i-- ) {
							listItemWidthTotal += elm.mTabs.tabsListItems[ i ].offsetWidth;
							if ( listItemWidthTotal <= tabAreaWidth ) {
								prevIndex = i;
							} else {
								i = -1;
							}
						}
					} else {
						// Do nothing
					}

					if ( prevIndex < 0 ) {
						prevIndex = 0;
					}

					scrollLeftPos = elm.mTabs.tabsListItems[ prevIndex ].offsetLeft - elm.mTabs.settings.offset;
					elm.mTabs.tabsNavList.scrollTo( scrollLeftPos, 0 );
					elm.mTabs.currentIndexes = mTabsFn.getCurrentIndexes( elm );
					elm.mTabs.settings.scrollLock = false;
				} else if ( elm.mTabs.direction === 'next' ) {
					currentIndex = elm.mTabs.currentIndexes[ 1 ];
					if ( currentIndex >= elm.mTabs.tabsCount - 1 ) {
						nextIndex = elm.mTabs.tabsCount - 1;
					} else if ( elm.mTabs.tabsNavList.scrollLeft === farRight ) {
						// Don't change, as already at far right
						nextIndex = currentIndex;
					} else {
						nextIndex = currentIndex + 1;
					}

					if ( nextIndex >= elm.mTabs.tabsListItems.length ) {
						nextIndex = elm.mTabs.tabsListItems.length - 1;
					}

					scrollLeftPos = elm.mTabs.tabsListItems[ nextIndex ].offsetLeft - elm.mTabs.settings.offset;
					elm.mTabs.tabsNavList.scrollTo( scrollLeftPos, 0 );
					elm.mTabs.currentIndexes = mTabsFn.getCurrentIndexes( elm );
					elm.mTabs.settings.scrollLock = false;
				} else {
					// Do nothing, as something's wrong
					elm.mTabs.settings.scrollLock = false;
				}
			}
		},

		tabClick : function( elm, tabControl, noHistory ) {
			// Fade to selected tab and alter elm height if necessary - standard tabs
			var href = tabControl.getAttribute( 'href' ),
				selected = elm.querySelector( href ),
				sourceHref,
				scrollParent,
				scrollParentPos,
				scrollLeftPos,
				scrollWindowPos;

			// Load in content for lazy-load tabs variant
			if ( elm.mTabs.settings.tabsLazy === true ) {
				if ( tabControl.getAttribute( 'data-href' ).match( '^#' ) || selected.classList.contains( 'js-loaded' ) ) {
					// Do nothing - this one's the original static content to leave in place, or additional content which has already been loaded
				} else {
					// Go get the content and ajax it in
					selected.querySelector( '.a-loading-indicator' ).style.display = 'block';
					sourceHref = tabControl.getAttribute( 'data-href' ).replace( '#', ' #' );
					utility.requestLoadInto( selected, sourceHref, function ajaxRequest( response, status ) {
						if ( status >= 200 && status < 400 ) {
							selected.classList.add( 'js-loaded' );
						} else {
							// Not found, so do nothing
						}
					});
				}
			}

			if ( noHistory ) {
				// Dont record the opening of the tab
			} else {
				utility.updateHistory( href );
			}

			scrollParent = utility.scrollParent( selected );
			scrollParentPos = scrollParent.scrollTop;
			scrollWindowPos = window.scrollY;

			elm.mTabs.tabsControls.forEach( function loop( tabControlElm ) {
				if ( tabControlElm.classList.contains( 'm-tabs__control--selected' ) ) {
					tabControlElm.classList.remove( 'm-tabs__control--selected' );
					tabControlElm.setAttribute( 'aria-selected', 'false' );
					tabControlElm.setAttribute( 'tabindex', -1 );
				}
				if ( tabControlElm.getAttribute( 'href' ) === href ) {
					tabControlElm.classList.add( 'm-tabs__control--selected' );
					tabControlElm.setAttribute( 'aria-selected', 'true' );
					tabControlElm.removeAttribute( 'tabindex' );
				}
			});

			elm.mTabs.tabsHeadings.forEach( function loop( heading ) {
				heading.style.display = 'none';
			});

			elm.mTabs.tabsContents.forEach( function loop( content ) {
				if ( content.classList.contains( 'm-tabs__content--selected' ) ) {
					content.classList.remove( 'm-tabs__content--selected' );
					content.setAttribute( 'aria-hidden', 'true' );
					content.style.display = 'none';
				}
			});

			selected.classList.add( 'm-tabs__content--selected' );
			selected.setAttribute( 'aria-hidden', 'false' );
			selected.setAttribute( 'tabindex', -1 );
			selected.style.display = 'block';
			selected.focus({ preventScroll : true });

			selected.previousElementSibling.removeAttribute( 'style' );
			scrollParent.scrollTop = scrollParentPos; // Reset to original position
			window.scroll( window.scrollX, scrollWindowPos ); // Reset to original position

			utility.trigger( window, 'refresh' );

			// Slide selected trigger to far left
			if ( elm.mTabs.settings.scrollLock ) {
				// Prevent scolling when already scrolling
			} else {
				scrollLeftPos = tabControl.parentNode.offsetLeft - elm.mTabs.settings.offset;
				elm.mTabs.tabsNavList.scrollTo( scrollLeftPos, 0 );
			}
		},

		tabsStatic : function( elm ) {
			var staticHeading = elm.querySelector( '.m-tabs__heading' ); // Returns first instance, which is what we want anyway
			staticHeading.classList.add( 'u-hidden--visually' );
		},

		tabsLazy : function( elm ) {
			// Get hard-coded static content for first tab, then remove the redundant div
			var staticContent = elm.querySelector( '.m-tabs__content' ), // Returns first instance, which is what we want anyway
				staticContent2 = staticContent.children[ 0 ],
				staticID = staticContent.id,
				selectedTab,
				headings;

			// Remove headings, then remove content
			headings = Array.from( staticContent.querySelectorAll( '.m-tabs__heading' ) ).filter( function filterFn( heading ) {
				return heading.closest( '.m-tabs' ) === elm;
			});
			headings.forEach( function loop( heading ) {
				heading.remove();
			});
			headings = staticContent.previousElementSibling;
			if ( headings && headings.classList.contains( 'm-tabs__heading' ) ) {
				headings.remove();
			}

			staticContent.remove();

			// Turn list into standard h3 + m-tabs__content markup
			elm.mTabs.tabsHeadings.forEach( function loop( heading ) {
				var href = heading.getAttribute( 'href' ),
					classes = heading.classList,
					title = heading.textContent,
					newTabH2,
					newTabH3,
					newTabContent;
				// Generate a string 'dataAttrs' from the non-js links containing all data attributes for replacing in the control
				let dataAttrs = '';
				// Retain datasets for click tracking
				Object.keys( heading.dataset ).forEach( key => {
					// Fix hyphenated key names
					let keyString = '';
					// Split data key into an array around uppercase with match if required
					let tempArr = key.match( /[A-Za-z][a-z]+/g );
					// Concatenate and drop to lowercase - unless there is no split array in which case use key
					keyString = tempArr === null ? keyString = key : keyString += 'data-' + tempArr.join( '-' ).toLowerCase();
					// Build the data attribute string for insertion
					dataAttrs += keyString + '="' + heading.dataset[ key ] + '"';
				});

				// Remove data class from classes
				classes.remove( 'dd-data-link' );

				if ( elm.mTabs.settings.tabsPrimary === true ) {
					newTabH2 = utility.htmlStringToElement( '<h2 data-href="' + href + '" class="' + classes + '" ' + dataAttrs + ' >' + title + '</h2>' );
					elm.append( newTabH2 );
				} else {
					newTabH3 = utility.htmlStringToElement( '<h3 data-href="' + href + '" class="' + classes + '" ' + dataAttrs + '>' + title + '</h3>' );
					elm.append( newTabH3 );
				}
				// eslint-disable-next-line max-len
				newTabContent = utility.htmlStringToElement( '<div class="m-tabs__content"><div class="a-loading-indicator" role="alert"><span class="a-loading-indicator__message">' + elm.mTabs.settings.loadingText + '</span></div>' );
				elm.append( newTabContent );
			});

			// Rediscover headings
			elm.mTabs.tabsHeadings = Array.from( elm.querySelectorAll( '.m-tabs__heading' ) ).filter( function filterFn( heading ) {
				return heading.closest( '.m-tabs' ) === elm && mTabsFn.filterParents( heading, 'm-tabs__content' ) === false;
			});

			// Find the selected tab and insert static content
			selectedTab = elm.querySelector( '.m-tabs__heading[data-href="#' + staticID + '"]' ).nextElementSibling;
			while ( selectedTab.firstChild ) {
				selectedTab.removeChild( selectedTab.firstChild );
			}
			if ( elm.mTabs.settings.tabsPrimary === true ) {
				selectedTab.append( staticContent2 );
			} else {
				selectedTab.append( staticContent );
			}
		},

		resizeRefresh : function( elm ) {
			// Resize function
			// eslint-disable-next-line complexity
			var onResizeRefresh = utility.debounce( function listener() {
				var listWidth = elm.mTabs.tabsNav.offsetWidth,
					listItemsWidth = 0,
					scrollLeftPos,
					tabSelected = elm.querySelector( '.m-tabs__control--selected' );

				elm.mTabs.tabsNav.classList.remove( 'm-tabs__nav--carousel' ); // Remove class to test widths properly

				elm.mTabs.tabsListItems.forEach( function loop( listItem ) {
					listItemsWidth += utility.outerWidthTrue( listItem );
				});

				if ( elm.mTabs.settings.tabsPrimary && listItemsWidth + elm.mTabs.settings.offset > listWidth && elm.mTabs.settings.carouselActive ) {
					// Primary - doesn't fit, but active carousel - update pagination controlls
					elm.mTabs.tabsNav.classList.add( 'm-tabs__nav--carousel' ); // Add class back
					setTimeout( function timeoutFn() {
						mTabsFn.updatePagination( elm );
					}, 5 );
				} else if ( listItemsWidth > listWidth && elm.mTabs.settings.carouselActive ) {
					// Standard - doesn't fit, but active carousel - update pagination controlls
					elm.mTabs.tabsNav.classList.add( 'm-tabs__nav--carousel' ); // Add class back
					setTimeout( function timeoutFn() {
						mTabsFn.updatePagination( elm );
					}, 5 );
				} else if ( elm.mTabs.settings.tabsPrimary && listItemsWidth + elm.mTabs.settings.offset > listWidth ) {
					// Primary - doesn't fit, no active carousel - set up carousel
					mTabsFn.tabsCarousel( elm );
				} else if ( listItemsWidth > listWidth ) {
					// Standard - doesn't fit, no active carousel - set up carousel
					mTabsFn.tabsCarousel( elm );
				} else if ( elm.mTabs.settings.carouselActive ) {
					// All fits, active carousel - destroy carousel
					elm.mTabs.tabsNav.classList.remove( 'm-tabs__nav--carousel' );
					elm.mTabs.settings.carouselActive = false;
					elm.mTabs.tabsNav.removeChild( elm.mTabs.pagination );
				} else {
					// All fits, no active carousel - do nothing
				}

				// Slide selected trigger to far left
				if ( elm.mTabs.settings.scrollLock ) {
					// Prevent scolling when already scrolling
				} else {
					scrollLeftPos = tabSelected.parentNode.offsetLeft - elm.mTabs.settings.offset;
					elm.mTabs.tabsNavList.scrollTo( scrollLeftPos, 0 );
				}
			}, 10 );

			// Create eventListeners
			window.addEventListener( 'resize', onResizeRefresh );
			window.addEventListener( 'refresh', onResizeRefresh, false );
			onResizeRefresh();
		},

		switchTabOnArrowPress : function( elm, event ) {
			var pressed = event.key,
				target = event.target,
				targetIndex = elm.mTabs.tabsControls.indexOf( target ),
				direction = elm.mTabs.settings.direction[ pressed ];

			if ( Number.isInteger( direction ) ) {
				if ( targetIndex >= 0 ) {
					if ( pressed === 'Home' ) {
						elm.mTabs.tabsControls[ 0 ].focus(); // Move to first tab
					} else if ( pressed === 'End' ) {
						elm.mTabs.tabsControls[ elm.mTabs.tabsControls.length - 1 ].focus(); // Move to last tab
					} else if ( elm.mTabs.tabsControls[ targetIndex + direction ] ) {
						elm.mTabs.tabsControls[ targetIndex + direction ].focus(); // Move by one tab left or right
					} else if ( direction === -1 ) {
						elm.mTabs.tabsControls[ elm.mTabs.tabsControls.length - 1 ].focus(); // Loop around to last tab
					} else if ( direction === 1 ) {
						elm.mTabs.tabsControls[ 0 ].focus(); // Loop around to first tab
					} else {
						// Do nothing
					}
				}
			}
		},
	};

	return {
		initInstance : function( elm ) {
			return mTabsFn.init( elm );
		},
	};
});
